// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"165":"cb6d9ab8","203":"b9be562a","368":"c0f5bb6b","423":"65e12f9a","796":"59cd267a","805":"c89e3c61","920":"9cf125c8","991":"85cb7f98"}[chunkId] + ".css";
};